export default "__VITE_PUBLIC_ASSET__cb260348__"